// Standalone entry point — loaded by index.html in dev/preview mode.
// In hosted mode, the host loads ./AppMount directly via Module Federation.
import { isTrue, loadAppSettings } from "./shared/config/appSettings";

async function startMocksIfEnabled(): Promise<void> {
  // import.meta.env.DEV is a build-time constant, so MSW is tree-shaken out of
  // production builds even if a deployed appsettings.json sets useMocks.
  if (!import.meta.env.DEV) return;
  const settings = await loadAppSettings();
  if (!isTrue(settings.useMocks)) return;
  const { startMockWorker } = await import("./shared/api/mocks/browser");
  await startMockWorker();
}

void startMocksIfEnabled().then(() =>
  import("./bootstrap").then(({ mount }) => {
    const devEl = document.getElementById("app");
    if (devEl) {
      void import("./shared/styles/global.css");
      void mount({ $element: devEl, standAlone: true });
    }
  }),
);
